/**
 * @generated SignedSource<<af40e428f68d2c1ef063181068679144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomsMessagingBody_viewer$data = {
  readonly customsDuties: {
    readonly duties: string | null;
  } | null;
  readonly " $fragmentType": "CustomsMessagingBody_viewer";
};
export type CustomsMessagingBody_viewer$key = {
  readonly " $data"?: CustomsMessagingBody_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomsMessagingBody_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "destinationCountry"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomsMessagingBody_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "destinationCountry",
          "variableName": "destinationCountry"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "CustomsDuties",
      "kind": "LinkedField",
      "name": "customsDuties",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duties",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f51d09441e61b69a6cec153c4a14e13a";

export default node;
